/** Store feature key of the ABCP correction-booking slice (REV-21375, ADR-0015). */
export const CLOSING_ADJUSTMENT_FEATURE_KEY = 'abcpClosingAdjustments';
